import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { trackCTAClick } from '../services/analytics'
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  VStack,
  HStack,
} from '@chakra-ui/react'
import LandingProductShot from './LandingProductShot.jsx'

const Hero = () => {
  const navigate = useNavigate()

  return (
    <Box
      data-landing="hero"
      minH={{ base: 'auto', lg: '88vh' }}
      bgGradient="linear(to-br, purple.50, white, gold.50)"
      display="flex"
      alignItems="center"
      pt={{ base: 16, md: 20 }}
      pb={{ base: 14, md: 20 }}
    >
      <Container maxW="7xl">
        <HStack
          gap={{ base: 10, lg: 16 }}
          align="center"
          flexDirection={{ base: 'column', lg: 'row' }}
        >
          <VStack
            flex={1}
            gap={{ base: 6, md: 8 }}
            align={{ base: 'center', lg: 'flex-start' }}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            <VStack gap={4} align={{ base: 'center', lg: 'flex-start' }}>
              <Heading
                as="h1"
                fontSize={{ base: '3xl', md: '5xl', lg: '6xl' }}
                fontWeight="800"
                lineHeight="1.1"
                color="gray.800"
              >
                Toda la gestión de tu banda, en un solo lugar.
                <Text as="span" color="purple.600" display="block" mt={2}>
                  Di adiós al excel y a la impresora.
                </Text>
              </Heading>
              <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="xl" lineHeight="tall">
                Cadencya ha llegado para gestionar toda tu banda: archivo musical, músicos, ensayos,
                contactos con entidades religiosas, actuaciones, métricas, encuestas, hasta tu propia web.
              </Text>
            </VStack>

            <HStack
              gap={4}
              w={{ base: 'full', sm: 'auto' }}
              flexDirection={{ base: 'column', sm: 'row' }}
              flexWrap="wrap"
              justify={{ base: 'center', lg: 'flex-start' }}
            >
              <Button
                size="lg"
                px={8}
                py={7}
                fontSize="lg"
                fontWeight="bold"
                bg="purple.600"
                color="white"
                rounded="full"
                _hover={{ bg: 'purple.700', transform: 'scale(1.05)' }}
                _active={{ transform: 'scale(0.98)' }}
                transition="all 0.2s"
                onClick={() => {
                  trackCTAClick('soy_banda', 'hero')
                  navigate('/registro?tipo=banda')
                }}
                w={{ base: 'full', sm: 'auto' }}
              >
                Soy una banda
              </Button>
              <Button
                size="lg"
                px={8}
                py={7}
                fontSize="lg"
                fontWeight="bold"
                bg="white"
                color="purple.600"
                border="2px solid"
                borderColor="purple.200"
                rounded="full"
                _hover={{ bg: 'purple.50', borderColor: 'purple.300', transform: 'scale(1.05)' }}
                _active={{ transform: 'scale(0.98)' }}
                transition="all 0.2s"
                asChild
              >
                <RouterLink
                  to="/hermandades"
                  onClick={() => trackCTAClick('hermandades', 'hero')}
                >
                  Soy una hermandad
                </RouterLink>
              </Button>
            </HStack>
          </VStack>

          <Box flex={1} w="full">
            <LandingProductShot variant="gestion" />
          </Box>
        </HStack>
      </Container>
    </Box>
  )
}

export default Hero
